import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Stack, Typography } from '@mui/material';
import CustomTabs from '../../components/CustomTabs/CustomTabs';
import CycleTriggerTable from './CycleTriggerTable';
import GlobalCycleTriggerTable from './GlobalCycleTriggerTable';
import { useOkta } from '../../hooks/oktaHook';
import cycle_trigger_image from '../../assests/images/cycle_trigger_image.svg';
import PageHeader from '../../components/PageHeader/PageHeader';

const CycleTrigger = () => {
  const { userDetails } = useOkta();
  const tabs = [
    { id: 'cycleTriggerTable', name: 'Cycle Trigger Table' },
    { id: 'globalCycleTriggerQueue', name: 'Global Cycle Trigger Queue' }
  ];

  const historicalCyclesValue = useSelector((state) => state.general.historicalCyclesValue);
  const [selectedTab, setSelectedTab] = useState(historicalCyclesValue);

  return (
    <Stack gap="24px" sx={{ padding: '24px', width: '100%' }}>
      <PageHeader pageHeader={'Cycle Trigger'} showBu={true} />
      <Stack
        direction="row"
        sx={{
          height: '100%',
          justifyContent: 'center',
          margin: '-30px 0px'
        }}>
        <Box
          gap={2}
          sx={{
            p: '0px 16px',
            height: '100%',
            alignItems: 'center'
          }}>
          <Typography variant="h5" sx={{ textAlign: 'center' }}>
            Welcome back to Cycle Trigger, {userDetails.username || ''}
          </Typography>
          <Typography
            sx={{ color: '#616161', fontSize: '14px', lineHeight: '40px', textAlign: 'center' }}>
            Don’t worry, if things change you can always edit this later.
          </Typography>
        </Box>
        <Box
          gap={2}
          sx={{
            p: '0px 16px',
            height: '100%'
          }}>
          <img src={cycle_trigger_image} alt={'cycle_trigger'} width={199} height={140} />
        </Box>
      </Stack>
      <CustomTabs tabs={tabs} selectedTab={selectedTab} onTabChange={setSelectedTab} />
      {selectedTab === 'cycleTriggerTable' && <CycleTriggerTable />}
      {selectedTab === 'globalCycleTriggerQueue' && <GlobalCycleTriggerTable />}
    </Stack>
  );
};

export default CycleTrigger;
